/**
 * SearchBar — search input z debounce. Wywołuje onChange po 200ms idle.
 * Clear button gdy są znaki. Focus ring sky-500.
 */
import { useEffect, useRef, useState } from 'react';
import { Icons } from '../Icons';

interface Props {
  onChange: (query: string) => void;
  placeholder?: string;
  delay?: number;
}

export function SearchBar({ onChange, placeholder = 'Szukaj transakcji...', delay = 200 }: Props) {
  const [value, setValue] = useState('');
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    const t = setTimeout(() => onChangeRef.current(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return (
    <div className="relative">
      <Icons.Search
        size={18}
        className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"
      />
      <input
        type="search"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        className="w-full pl-10 pr-9 py-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-4 focus:ring-sky-500/10 transition-all text-sm"
        aria-label="Szukaj transakcji"
      />
      {value && (
        <button
          type="button"
          onClick={() => setValue('')}
          aria-label="Wyczyść"
          className="absolute right-2.5 top-1/2 -translate-y-1/2 p-1.5 text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
        >
          <Icons.X size={16} />
        </button>
      )}
    </div>
  );
}
